// extracted by mini-css-extract-plugin
module.exports = {"main-component":"morale_main-component__22stP"};